<script>
import Daily from './schedule/Daily.vue'
import SmallTabHeader from "@/components/common/tabs/SmallTabHeader.vue";

export default {
  components: {SmallTabHeader, Daily},
  props: {
    value: {type: Object},
    fillWidth: {type: Boolean}
  },
  data: vm => ({
    selected: vm.value.type || vm.$enums.ScheduledType.Instantly,
    values: [{
      value: vm.$enums.ScheduledType.Daily,
      date: {date: 0, time: vm.setTime(vm.$enums.ScheduledType.Daily)}
    }]
  }),
  computed: {
    title() {
      return this.$t('component.profile.printParameters.shipping.manager');
    },
    subTitle() {
      return this.$t('component.profile.printParameters.send.open');
    }
  },
  methods: {
    handleChange(scheduledType, newDate = null) {
      if (!this.canLoadData(4) && this.selected === null) {
        this.resetToInstantly()
        return
      }
      let selectedOption = this.values.find(option => option.value === scheduledType)
      if (!selectedOption) {
        this.resetToInstantly()
        return
      }
      this.updateTypeOnDeselect(scheduledType)
      if (newDate) {
        this.updateTime(selectedOption, newDate)
      }
      this.assignNewValues(scheduledType, selectedOption.date || {})
      this.selected = this.value.type
    },
    resetToInstantly() {
      this.value.type = this.$enums.ScheduledType.Instantly
    },
    updateTypeOnDeselect(scheduledType) {
      if (scheduledType !== this.$enums.ScheduledType.Daily) {
        this.value.type = this.$enums.ScheduledType.Instantly
        this.value.date = null
      }
    },
    updateTime(selectedOption, newDate) {
      selectedOption.date.time = {
        hour: this.forceTwoDigits(newDate.hour),
        minutes: this.forceTwoDigits(newDate.minutes)
      }
    },
    assignNewValues(scheduledType, selectedDate) {
      this.value.date = this.getDate(scheduledType, selectedDate)
      this.value.type = scheduledType
      this.value.dayOfWeek = null
      this.$emit('input', this.value)
    },
    getDate(scheduledType, selectedDateObj) {
      if (scheduledType === this.$enums.ScheduledType.Instantly) {
        return null
      }
      return this.momentDate({hour: selectedDateObj.time.hour, minute: selectedDateObj.time.minutes})
    },
    setTime(type) {
      if (!this.value.date) {
        return this.defaultTime()
      }
      return type === this.value.type ? this.extractTime(this.value.date) : this.defaultTime()
    },
    defaultTime() {
      return {hour: this.forceTwoDigits(14), minutes: this.forceTwoDigits(0)}
    },
    extractTime(date) {
      return {
        hour: this.forceTwoDigits(this.momentDate(date).hour()),
        minutes: this.forceTwoDigits(this.momentDate(date).minutes())
      }
    },
    canLoadData(type) {
      return type !== null
    }
  }
}
</script>
<template>
  <v-container>
    <v-row justify="space-around">
      <v-hover v-slot="{ hover }">
        <v-col cols="12" :sm="!fillWidth && 6">
          <SmallTabHeader
            :title="$t('component.profile.printParameters.shipping.manager')"
            subtitle=""
            :is-action-visible="false"/>
          <h4 class="font-weight-bold mb-2 wordBreak">
            <!--          <span v-html="title" />-->
            <div v-if="fillWidth" class="d-inline">
              <v-tooltip top max-width="600">
                <template #activator="{ on }">
                  <v-icon
                    color="primary"
                    class="information-icon"
                    :class="{ 'on-hover': hover }"
                    v-on="on"
                  >mdi-information
                  </v-icon>
                </template>
                <span v-html="subTitle"/>
              </v-tooltip>
            </div>
          </h4>
          <span v-if="!fillWidth" class="text-body-2 secondary--text" v-html="subTitle"/>
          <div v-for="(option, index) in values" :key="index">
            <v-row align="center" no-gutters class="pa-0 d-flex align-center">
              <v-checkbox
                id="shippingParamCheckbox"
                v-model="selected"
                name="shippingManager"
                class="font-weight-bold"
                :value="option.value"
                :disabled="!canLoadData(option.value)"
                @change="handleChange($event)"
              ></v-checkbox>
              <Daily
                v-model="option.date"
                :disabled="selected !== option.value"
                @input="handleChange(selected, $event.date)"/>
            </v-row>
          </div>
        </v-col>
      </v-hover>
    </v-row>
  </v-container>
</template>

<style lang="scss">
.menu_extended_height {
  max-height: 400px !important;
}
</style>
